import type { ArticleCard } from '~kui/components/KUI/Unified/Content/types';

import { blurBackgroundImage } from '~kui/utils/blurBackground';

import type { ArticlePublicPathInput } from '~/constants/routes/unified';
import type { FragmentType } from '~/graphql/generated/fragment-masking';

import { ARTICLE_TEMPLATES } from '~/components/Article/articleTemplates';
import { articlePublicPath } from '~/constants/routes/unified';
import { articleCardFieldsFragment } from '~/graphql/documents/learn/articles';
import { useFragment } from '~/graphql/generated/fragment-masking';

export type { ArticleCard };

const GENERIC_BADGE_KEY = 'unified.articles.badge';

interface ArticleCardOptions {
  t: (key: string) => string;
  articlePath?: (article: ArticlePublicPathInput) => string;
}

/** Maps a published article to a card linking where `articlePath` says (the public page by default). */
export const toArticleCard = (
  data: FragmentType<typeof articleCardFieldsFragment>,
  { t, articlePath = articlePublicPath }: ArticleCardOptions,
): ArticleCard => {
  const asset = useFragment(articleCardFieldsFragment, data);
  const template = asset.publishedContent?.articleData?.template;
  return {
    id: asset.id,
    name: asset.name,
    slug: asset.slug,
    imageUrl: asset.coverImage?.publicUrl ?? blurBackgroundImage(asset.id),
    badge: t((template && ARTICLE_TEMPLATES[template]?.badgeKey) || GENERIC_BADGE_KEY),
    readingTimeMinutes: asset.publishedContent?.articleData?.readingTimeMinutes ?? null,
    to: articlePath(asset),
    partnerName: asset.partner?.name ?? undefined,
    partnerLogoUrl: asset.partner?.iconFile?.publicUrl ?? undefined,
  };
};

export const toArticleCards = (
  assets: readonly FragmentType<typeof articleCardFieldsFragment>[],
  options: ArticleCardOptions,
): ArticleCard[] => assets.map(data => toArticleCard(data, options));
